import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from "@angular/router";
import { BaseAccountService } from "admin/baseLogin/BaseAccountService";
import { AppConstants } from "admin/utile/AppConstants";
import { RouterUtils } from "admin/_global/GlobalUtils";
import { Observable } from "rxjs";

export class BaseGuard
{
    constructor(
        protected accountService: BaseAccountService,
        protected router: Router,
        protected appUrl: string)
    {

    }

    CompanyJoinCanActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        return new Observable<boolean>(o => {
            this.accountService.isAuthenticated().subscribe(
                result => {
                    if (!result.Success) {
                        const code: string = RouterUtils.GetParamByNameFromSnapshotRoot(state.root, "code");

                        if (code) {
                            this.router.navigate(['/login/company-join/' + code]);
                        }
                        else {
                            this.router.navigate(['/login']);
                        }
                    }

                    o.next(result.Success);
                    o.complete();
                },
                error => {
                    o.next(false);
                    o.error(error);
                }
            );
        });
    }

    CompanyCanActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        return new Observable<boolean>(o => {
            this.accountService.isAuthenticated().subscribe(
                result => {
                    if (!result.Success) {
                        this.router.navigate(['/login']);
                    }

                    o.next(result.Success);
                    o.complete();
                },
                error => {
                    o.next(false);
                    o.error(error);
                }
            );
        });
    }

    HasCompanyCanActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        return new Observable<boolean>(o => {
            this.accountService.hasCompanySet().subscribe(
                result => {
                    if (result.Success) {
                        this.router.dispose();
                        window.location.replace(AppConstants.baseUrl + this.appUrl);
                    }

                    o.next(!result.Success);
                    o.complete();
                },
                error => {
                    o.next(false);
                    o.error(error);
                }
            );
        });
    }

    ForgotPassCanActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        return new Observable<boolean>(o => {
            this.accountService.isAuthenticated().subscribe(
                result => {
                    if (result.Success) {
                        const code: string = RouterUtils.GetParamByNameFromSnapshotRoot(state.root, "code");

                        if (code) {
                            this.router.navigate(['/login/company-join/' + code]);
                        }
                        else {
                            this.router.navigate(['/login']);
                        }
                    }

                    o.next(!result.Success);
                    o.complete();
                },
                error => {
                    o.next(false);
                    o.error(error);
                }
            );
        });
    }

    LoginCanActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        return new Observable<boolean>(o => {
            this.accountService.isAuthenticated().subscribe(
                result => {
                    if (result.Success) {
                        const code: string = RouterUtils.GetParamByNameFromSnapshotRoot(state.root, "code");

                        if (code) {
                            this.router.navigate(['/company-join/' + code]);
                        }
                        else {
                            this.router.navigate(['/company-signup']);
                        }
                    }

                    const canActivate = !result.Success;
                    o.next(canActivate);
                    o.complete();
                },
                error => {
                    o.next(true);
                    o.error(error);
                }
            );
        });
    }

    RegisterCanActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        return new Observable<boolean>(o => {
            this.accountService.isAuthenticated().subscribe(
                result => {
                    if (result.Success) {
                        const code: string = RouterUtils.GetParamByNameFromSnapshotRoot(state.root, "code");

                        if (code) {
                            this.router.navigate(['/login/company-join/' + code]);
                        }
                        else {
                            this.router.navigate(['/login']);
                        }
                    }
                    const canActivate = !result.Success;
                    o.next(canActivate);
                    o.complete();
                },
                error => {
                    o.next(true);
                    o.error(error);
                }
            );
        });
    }
}